import { render, staticRenderFns } from "./bindAccount.vue?vue&type=template&id=fbc5ad38&scoped=true"
import script from "./bindAccount.vue?vue&type=script&lang=js"
export * from "./bindAccount.vue?vue&type=script&lang=js"
import style0 from "./bindAccount.vue?vue&type=style&index=0&id=fbc5ad38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc5ad38",
  null
  
)

export default component.exports